import React from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { IconDownload } from "@tabler/icons-react";
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableDocumentSupports = (props) => {
  // console.log(props.listEp)

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: "Aksi",
      cell: (row) => (
        <>
          <button
            onClick={() => props.showDocument(row.id)}
            className="btn btn-danger btn-sm"
            type="button"
          >
            <IconDownload stroke={2} /> Download
          </button>
        </>
      ),
    },
    {
      name: "Bab",
      width: "100px",
      selector: (row) => row.skor.chapters_accreditation.Singkatan,
    },
    {
      name: "Elemen Penilaian",
      width: "350px",
      cell: (row) => (
        <>
          {row.skor.variables_accreditation.Abjad.concat(". ").concat(
            row.skor.variables_accreditation.Deskripsi
          )}
        </>
      ),
    },
    {
      name: "Nama File",
      selector: (row) => row.namaFile,
    },
    {
      name: "Deskripsi",
      selector: (row) => row.Deskripsi,
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        data={props.documents}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Search Nama File & Deskripsi"
            className="w-50 form-control m-3"
            values={props.search}
            onChange={(e) => props.handleChangeSearch(e.target.value)}
          />
        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatableDocumentSupports;
